import { IQueryParams } from "models/dto/ZoomiLxp/Models/Query/IQueryParams";
import Api, { ApiBase } from "../utils/api";
import { AxiosResponse } from "axios";
import { IGroupStatisticItem } from "models/dto/ZoomiLxp/Models/GroupModels/IGroupStatisticItem";
import { IGetRecordsResponse } from "models/dto/ZoomiLxp/Models/Common/IGetRecordsResponse";
import { IResponseModel } from "models/dto/ZoomiLxp/Models/Common/IResponseModel";
import { IGroupModel } from "models/dto/ZoomiLxp/Models/GroupModels/IGroupModel";
import { IUpdateGroupModel } from "models/dto/ZoomiLxp/Models/GroupModels/IUpdateGroupModel";
import { ICreateGroupModel } from "models/dto/ZoomiLxp/Models/GroupModels/ICreateGroupModel";
import { ISetGroupCoursesModel } from "models/dto/ZoomiLxp/Models/GroupModels/ISetGroupCoursesModel";
import { IPreviewGroupModel } from "models/dto/ZoomiLxp/Models/GroupModels/IPreviewGroupModel";
import { IGroupHomePageModel } from "models/dto/ZoomiLxp/Models/GroupModels/IGroupHomePageModel";
import { ICommitGroupMembersModel } from "models/dto/ZoomiLxp/Models/GroupModels/Preview/ICommitGroupMembersModel";
import { ICommitGroupMembersResponse } from "models/dto/ZoomiLxp/Models/GroupModels/Preview/ICommitGroupMembersResponse";
import { IPreviewGroupMembersModel } from "models/dto/ZoomiLxp/Models/GroupModels/Preview/IPreviewGroupMembersModel";
import { IPreviewGroupMembersResponse } from "models/dto/ZoomiLxp/Models/GroupModels/Preview/IPreviewGroupMembersResponse";
import { IPagingParams } from "models/dto/ZoomiLxp/Models/Query/IPagingParams";
import { IGroupProfileItemModel } from "models/dto/ZoomiLxp/Models/GroupModels/IGroupProfileItemModel";

export class GroupsApi {
	static searchGroups(data: IQueryParams) {
		return ApiBase.post<IQueryParams, AxiosResponse<IResponseModel<IGetRecordsResponse<IPreviewGroupModel>>>>(
			"/Group/SearchGroups",
			data
		);
	}

	static getCreatedByAuthors() {
		return Api.get("/Group/GetCreatedByAuthors");
	}

	static getGroupsStatistic(data: IQueryParams) {
		return Api.postUnwrapped<IGetRecordsResponse<IGroupStatisticItem[]>>("/group/groupsStatistic", data);
	}

	static getMyGroupsProfile(data: IQueryParams, onlyCertifications: boolean) {
		return Api.get<IGetRecordsResponse<IGroupProfileItemModel>>("/Group/MyGroupsProfile", {
			params: {
				QueryString: data.queryString,
				Skip: data.skip,
				Take: data.take,
				onlyCertifications,
			},
		});
	}

	static getUserGroupsProfile(accountId: number, data: IQueryParams, onlyCertifications: boolean) {
		return Api.get<IGetRecordsResponse<IGroupProfileItemModel>>(`/Group/UserGroupsProfile/${accountId}`, {
			params: {
				QueryString: data.queryString,
				Skip: data.skip,
				Take: data.take,
				onlyCertifications,
			},
		});
	}

	static getMyGroups(data: IPagingParams) {
		return Api.get<IGetRecordsResponse<IPreviewGroupModel>>("/HomePage/MyGroups", {
			params: data,
		});
	}

	static getTrendingGroups(data: IPagingParams) {
		return Api.get<IGetRecordsResponse<IPreviewGroupModel>>("/HomePage/TrendingGroups", {
			params: data,
		});
	}

	static getPromoGroups(data: IPagingParams) {
		return Api.get<IGetRecordsResponse<IPreviewGroupModel>>("/HomePage/PromoGroups", {
			params: data,
		});
	}

	static getGroup(id: number) {
		return Api.get<IGroupModel>(`/group/${id}`);
	}

	static getGroupHome(id: number, trackView = true) {
		return Api.get<IGroupHomePageModel>(`/Group/${id}/Home`, { params: { trackView } });
	}

	static joinGroup(id: number) {
		return Api.postUnwrapped<object>(`/Group/${id}/Join`);
	}

	static addGroup(data: ICreateGroupModel) {
		return Api.post<IGroupModel, ICreateGroupModel>("/group/AddGroup", data);
	}

	static updateGroup(id: number, data: IUpdateGroupModel) {
		return Api.put<IGroupModel, IUpdateGroupModel>(`/group/UpdateGroup/${id}`, data);
	}

	static deleteGroup(id: number) {
		return Api.delete<object>(`/group/${id}`);
	}

	static deleteGroupFromCourse(groupId: number, courseId: number) {
		return Api.delete<object>(`/group/fromCourse/${groupId}/${courseId}`);
	}

	static setGroupCourses(groupId: number, data: ISetGroupCoursesModel) {
		return Api.put<object, ISetGroupCoursesModel>(`/group/${groupId}/Courses`, data);
	}

	static previewGroupMembers(groupId: number, data: IPreviewGroupMembersModel) {
		return Api.post<IPreviewGroupMembersResponse, IPreviewGroupMembersModel>(`/Group/${groupId}/PreviewMembers`, data);
	}

	static commitGroupMembers(groupId: number, data: ICommitGroupMembersModel) {
		return Api.post<ICommitGroupMembersResponse, ICommitGroupMembersModel>(`/Group/${groupId}/CommitMembers`, data);
	}

	static deleteGroupFromThread(groupId: number, threadId: number) {
		return Api.delete<object>(`/group/fromThread/${groupId}/${threadId}`);
	}

	static deleteGroupFromUser(groupId: number, userId: number) {
		return Api.delete<object>(`/group/fromUser/${groupId}/${userId}`);
	}
}
